export default __webpack_public_path__ + "static/media/key-door.3fc2803d.svg";